module.exports = __webpack_public_path__ + "static/media/generic-cu.cf85167a.jpeg";